// *** IMPORTANT IMPLEMENTATION NOTE - READ BEFORE USE ***
// https://github.com/marmelab/react-admin/blob/872480a9a4a8491066eb8b1f0f651e48f47e9080/packages/ra-ui-materialui/src/form/TabbedForm.tsx#L209
// react-admin renders ALL tabs w/in TabbedForm and then uses css to hide tabs that aren't in focus.

import React, { FC } from 'react'

import { FormTab, TabbedForm, useRecordContext } from 'react-admin'

export const PowCloudRATabbedForm: FC<{
  children: any
  toolbar?: any
  saving?: any
  variant?: 'standard' | 'outlined' | 'filled'
}> = ({ children, ...rest }) => {
  const record = useRecordContext()

  // Disables children FormTabs when form is saving.
  // *** NOTE this only works when parent component (Create / Edit) have undoable toggled off ***
  return (
    <TabbedForm
      // style={{ height: '100vh' }}
      // toolbar={
      //   <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      //     <SaveButton />
      //     <DeleteButton
      //       confirmTitle={`Deleting "${record.name}" with id "${record.id.slice(0, 4)}...${record.id.slice(32)}"`}
      //     />
      //   </Toolbar>
      // }
      {...rest}
    >
      {children.map((child, i) => React.cloneElement(child, { record, disabled: rest.saving, key: i }))}
    </TabbedForm>
  )
}

export const PowCloudRAFormTab: FC<{ children: any; hidden?: boolean; label: any; path: string }> = ({
  children,
  ...tabProps
}) => {
  // TabbedForm passes a hidden props to it's children FormTabs.
  // This component passes that hidden props through to the FormTab's
  // children.
  return <FormTab {...tabProps}>{React.cloneElement(children, { hidden: tabProps.hidden })}</FormTab>
}
